import {Component} from '@angular/core';
import {BasePatientPage} from "../../base-patient-page";
import {FormsModule} from "@angular/forms";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatIconModule} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";

/** The document information for a patient */
@Component({
	selector: 'app-docs',
	imports: [
		FormsModule,
		MatCheckboxModule,
		MatIconModule,
		MatIconButton
	],
	templateUrl: './docs.component.html',
	styleUrl: './docs.component.scss'
})
export class DocsComponent extends BasePatientPage {

	async completeAll() {
		this.completeCategory(this.controller.docs).then();
	}
}
